import { ToastType } from "@/models/app";
import { useToastStore } from "@/stores/toast";
import * as amplitude from "@amplitude/analytics-browser";

const useToast = (message: string, type: ToastType = ToastType.Info, timeout: number = 5000): void => {
  if(type == ToastType.Error) {
    amplitude.track('Error Displayed', {
      "Error Type": message,
      "PageUrl": window.location.href,
    });
  }

  useToastStore().add({ message, type, timeout });
}

export default useToast;
